import React from 'react'
import Imgix from 'react-imgix'
import { FullWidthImageOverlayComponentProps } from './FullWidthImageOverlayComponentProps'
import useStyles from './FullWidthImageOverlayComponent.styles'
import ResponsiveImage from '../../utils/ResponsiveImage'

const FullWidthImageOverlayComponent: React.FC<FullWidthImageOverlayComponentProps> =
  ({
    image,
    mobileImage,
    text,
    watermark
  }: FullWidthImageOverlayComponentProps) => {
    const mobileImageSrc = mobileImage?.src ?? image.src
    const classes = useStyles()

    return (
      <ResponsiveImage src={image.src} mobileSrc={mobileImageSrc}>
        <div className={classes.overlay}>
          <div className={classes.overlayText}>{text}</div>
          {watermark && (
            <Imgix
              htmlAttributes={{
                alt: 'Watermark'
              }}
              sizes="128px"
              className={classes.watermark}
              src={watermark.src}
            />
          )}
        </div>
      </ResponsiveImage>
    )
  }

export default FullWidthImageOverlayComponent
